import { render, staticRenderFns } from "./DetailDrawer.vue?vue&type=template&id=4af9d6a6&scoped=true"
import script from "./DetailDrawer.vue?vue&type=script&lang=js"
export * from "./DetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./DetailDrawer.vue?vue&type=style&index=0&id=4af9d6a6&lang=less&scoped=true"
import style1 from "./DetailDrawer.vue?vue&type=style&index=1&id=4af9d6a6&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af9d6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af9d6a6')) {
      api.createRecord('4af9d6a6', component.options)
    } else {
      api.reload('4af9d6a6', component.options)
    }
    module.hot.accept("./DetailDrawer.vue?vue&type=template&id=4af9d6a6&scoped=true", function () {
      api.rerender('4af9d6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/DetailDrawer.vue"
export default component.exports